module.exports = __webpack_public_path__ + "static/media/image-placeholder.6db652e7.png";